import Grid from '@material-ui/core/Grid';
import { ChangeEvent, ReactElement, ReactNode } from 'react';

import GlobalUserBadge from '../TeamMemberAccordion/GlobalUserBadge';
import TeamMemberAccordion from '../TeamMemberAccordion/TeamMemberAccordion';
import { NormalizedTeamMembersAllocations } from '../../model/types';
import { IDatesValidation } from '~/services/api/clientAllocation';
import getTeamMemberDatesErrors from '../../helpers/getTeamMemberDatesErrors';

import styles from '../AddAllocationFormLayout/AddAllocationFormLayout.module.scss';

interface IProps {
  teamMembersAllocations: NormalizedTeamMembersAllocations[];
  clinicId: string;
  expandedPanelIds: Set<string>;
  isLocationGroupsMode: boolean;
  datesValidation?: IDatesValidation;
  onToggle: (
    panelId: string,
  ) => (event: ChangeEvent<Record<string, unknown>>, isExpanded: boolean) => void;
  renderMemberContent: (allocationIdx: number) => ReactNode;
}

const AllocationMembersList = ({
  teamMembersAllocations = [],
  clinicId,
  expandedPanelIds,
  isLocationGroupsMode,
  onToggle,
  renderMemberContent,
  datesValidation,
}: IProps): ReactElement => (
  <>
    {teamMembersAllocations.map((teamMember, teamMemberIdx) => {
      const allocatedClientsCount = isLocationGroupsMode
        ? new Set(teamMember.locationGroupAllocations.map(allocation => allocation.locationGroupId))
            .size
        : teamMember.clientsAllocations.length + teamMember.crisisAllocations.length;
      const datesErrors = getTeamMemberDatesErrors(teamMember.id, datesValidation);

      return (
        <div key={teamMember.id}>
          <TeamMemberAccordion
            panelId={String(teamMember.id)}
            teamMemberId={teamMember.id}
            name={teamMember.name}
            photo={teamMember.photo}
            datesValidation={datesValidation}
            countLabel={`${allocatedClientsCount} ${
              isLocationGroupsMode ? 'Location Groups' : 'Allocated Clients'
            }`}
            expanded={expandedPanelIds.has(String(teamMember.id))}
            onToggle={onToggle}
            badge={<GlobalUserBadge roles={teamMember.roles} clinicId={clinicId} />}
          >
            <Grid container spacing={3}>
              {datesErrors?.showDifferentTeamErrorMessage && (
                <Grid container>
                  <Grid item sm={12} className={styles.validationErrors}>
                    Note: this user has assigned client allocations for this date on other teams
                  </Grid>
                </Grid>
              )}
              <Grid item sm={12}>
                {renderMemberContent(teamMemberIdx)}
              </Grid>
            </Grid>
          </TeamMemberAccordion>
        </div>
      );
    })}
  </>
);

export default AllocationMembersList;
